export default ['kw_price_request', 'is_bestseller', 'is_vegan', 'kw_sustainable'];
